import React, { useState } from 'react';
import { Loader } from '@fourthwall/components';
import * as S from './styled';
export const Guide = ({ active = false, shouldLoad, url, onLoad }) => {
    const [isLoading, setIsLoading] = useState(true);
    return (React.createElement(S.Container, { active: active },
        isLoading && (React.createElement(S.LoaderWrapper, null,
            React.createElement(Loader, { size: "medium" }))),
        React.createElement("iframe", { src: shouldLoad ? url : undefined, loading: active ? 'eager' : 'lazy', width: "100%", height: "100%", onLoad: () => {
                setIsLoading(false);
                onLoad?.();
            } })));
};
